import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar,} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {LeavePageVO, useQueryLeavePage} from "@/service/leave.s";
import {WriteLeave} from "@/pages/Leave/WriteLeave";
import {ViewLeave} from "@/pages/Leave/ViewLeave";
import {Avatar} from "@mui/material";
import Chip from "@mui/material/Chip";
import {ReviewStatus} from "@/widget/ReviewStatus/ReviewStatus";
import {useAuthInfo} from "@/store/account.c";
import {PatentPageVO} from "@/service/patent.s";
import {permScope} from "@/helper/constant";

export const LeaveListPage = () => {
    const {
        mutate: leavePageMutate,
        data: leavePageData,
        isPending: leavePagePending,
    } = useQueryLeavePage()
    const {id: authId, role: {dataScope}} = useAuthInfo()

    const columns: GridColDef<LeavePageVO>[] = [
        {
            field: "categories",
            headerName: "类别",
            headerAlign: "left",
            align: "left",
            flex: 0.35,
            display: "flex",
            renderCell: ({row}) => <Chip label={row.categories}/>,
        },

        {
            field: "createdAt",
            headerName: "请假时间",
            flex: 0.8,
            renderCell: ({row}) => {
                return `${formatTime("m", row.startTime)}至${formatTime("m", row.endTime)}`;
            }
        },
        {
            field: "creator",
            headerName: "创建人",
            headerAlign: "center",
            align: "center",
            display: 'flex',
            flex: 0.3,
            renderCell: ({row}) => <Avatar {...stringAvatar(row.creator)} />
        },
        {
            field: "deptName",
            headerName: "部门",
            headerAlign: "center",
            align: "center",
            flex: 0.28,
        },
        {
            field: "leaveDays",
            headerName: "请假天数",
            headerAlign: "center",
            align: "center",
            flex: 0.28,
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
            renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={authId} auditStatus={row.auditStatus} nodeNames={row.nodeNames}/>,
        },
        {
            field: "reason",
            headerName: "事由",
            flex: 0.5,
        },
    ];

    return (
        <ProTable<LeavePageVO>
            loading={leavePagePending}
            columnVisibilityModel={{creator: dataScope !== permScope['self']}}
            renderDrawer={{view: <ViewLeave/>, write: <WriteLeave/>}}
            columns={columns}
            data={leavePageData?.data}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                    viewBtnCallback: (row: PatentPageVO) => {
                        return {businessId: row.id, instanceId: row.instanceId, updateForm: <WriteLeave/>}
                    }
                }
            }}
            onSearch={(params) => {
                leavePageMutate(params);
            }}
            code={"leave"}
        />
    );
};
